import { useEffect } from "react"
import {
  Amenities as TabletAmenities,
  Landing as TabletLanding,
  Location as TabletLocation,
  Residences as TabletResidences,
} from "@pages/tablet"

import {
  Amenities as ScreenAmenities,
  Landing as ScreenLanding,
  Location as ScreenLocation,
  Residences as ScreenResidences,
} from "@pages/screen"

import useStore from "@state/store"
function iOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  )
}

export const istablet_GLOBAL = window.innerWidth < 1424
// export const istablet_GLOBAL = iOS() || window.innerWidth < 1024
// export const istablet_GLOBAL = true

const RoutesConfig = () => {
  // Override the default value of isTablet with the value from the store
  const { setLocalState } = useStore((s) => ({
    setLocalState: s.setLocalState,
  }))
  const isTablet = istablet_GLOBAL
  // || true
  useEffect(() => {
    setLocalState({ isTablet: isTablet })
  }, [isTablet])

  const Landing = isTablet ? TabletLanding : ScreenLanding
  const Amenities = isTablet ? TabletAmenities : ScreenAmenities
  const Location = isTablet ? TabletLocation : ScreenLocation
  const Residences = isTablet ? TabletResidences : ScreenResidences

  const routes = [
    {
      name: "Landing",
      path: "/",
      exact: true,
      isNavLink: false,
      element: Landing,
    },
    {
      name: "Upper West Side",
      path: "/location",
      exact: true,
      isNavLink: true,
      element: Location,
    },
    {
      name: "Amenities",
      path: "/amenities",
      exact: true,
      isNavLink: true,
      element: Amenities,
    },
    {
      name: "Residences",
      path: "/residences",
      exact: true,
      isNavLink: true,
      element: Residences,
    },
  ]

  return { routes, isTablet }
}

export default RoutesConfig
